const IST = "Asia/Kolkata";

/**
 * MySQL is queried with timezone 'Z' + dateStrings, so timestamps arrive as
 * "YYYY-MM-DD HH:mm:ss" with no offset. Treat those as UTC, then display IST.
 */
export function parseServerDate(value) {
  if (value == null || value === "") return null;
  if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value;
  const s = String(value).trim();
  if (!s) return null;
  if (/[zZ]$/.test(s) || /[+-]\d{2}:?\d{2}$/.test(s)) {
    const d = new Date(s);
    return Number.isNaN(d.getTime()) ? null : d;
  }
  const d = new Date(s.replace(" ", "T") + "Z");
  return Number.isNaN(d.getTime()) ? null : d;
}

export function fmtIST(value, opts = {}) {
  const d = parseServerDate(value);
  if (!d) return "—";
  return d.toLocaleString("en-IN", {
    timeZone: IST,
    day: "2-digit",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
    ...opts,
  });
}
